import { PaymentOption } from '@/hooks/usePaymentOptions';

export enum CTA_COLORS {
  DEFAULT = 'deep_blue', // This is the color that the buttons will use by default
  INDIGO = 'indigo',
  DEEP_BLUE = 'deep_blue',
  DARK_GRAY = 'dark_gray',
  LIME_GREEN = 'lime_green',
  YELLOW = 'yellow',
  RED = 'red_v2',
}

export type TypeCtaColors =
  | CTA_COLORS.DEFAULT
  | CTA_COLORS.INDIGO
  | CTA_COLORS.DEEP_BLUE
  | CTA_COLORS.DARK_GRAY
  | CTA_COLORS.LIME_GREEN
  | CTA_COLORS.YELLOW
  | CTA_COLORS.RED;

export type PaymentOptionExtend = PaymentOption & {
  singleAddonPrice: number;
  isAddon: boolean;
};
